<itl-single-order-article-list-item
  [articleNotAvailable]="!canBeOrdered"
  [articleForUse]="article.prescriptionType && article.prescriptionType === 5"
  [articleNotFoundInCareproposal]="articleLine.notInIntegratedCare"
  [isNew]="articleLine.isNew"
  [isInAbo]="articleLine.isInSeries"
  [isLast]="isLast"
  [maxQuantityReached]="
    articleLine.active &&
    (articleLine.maxAmount
      ? articleLine.maxAmount.currentQuantity > articleLine.maxAmount.maxQuantityBaseOnScope
      : false)
  "
  [articleIsDelayed]="articleIsDelayed"
  [delayedTo]="delayedTo"
>
  <itl-integratedcare-article
    [article]="article"
    [hasCheckbox]="!isArticleEditDisabled"
    [isChecked]="articleLine.active"
    (checked)="activeToggled()"
    [labelIsPrivateSale]="articleLine?.isPrivateSale"
    [(articleExpanded)]="showDetails"
    [hasAdditionalCards]="
      articleLine.contract ||
      articleLine.batchNumber ||
      articleLine.serialNumber ||
      (articleLine.active && articleLine.maxAmount)
    "
    [stock]="stock ? stock[articleLine?.article?.customerNumber] : null"
    [disabled]="isArticleEditDisabled"
  >
    <ng-container slot="dosage">
      {{ articleLine?.quantity }} {{ articleLine?.unit | articleUnitPipe }} ({{ articleLine?.packagingUnit?.quantity }}
      {{ 'order.edit.unit' | translate }})

      <div
        class="recommendationAmount"
        *ngIf="!articleLine?.notInIntegratedCare && !order.rootId && !isArticleEditDisabled"
      >
        <span>
          <ion-icon name="alberta-return-arrow"></ion-icon>
          <a (click)="setRecommendedQuantity()">
            {{ articleLine?.recommendedQuantity }} {{ articleLine?.unit | articleUnitPipe }}. ({{
              articleLine?.packagingUnit?.quantity
            }}.) {{ 'order.edit.setrecommended' | translate }}
          </a>
        </span>
      </div></ng-container
    ><ng-container slot="AdditionalCards">
      <itl-card *ngIf="articleLine.contract" [header]="'order.edit.contract' | translate">
        {{ articleLine.contract.name }}
      </itl-card>
      <itl-card [header]="'integratedCare.articleLine.batchNumber' | translate">
        {{ articleLine.batchNumber ? articleLine.batchNumber : 'k.A.' }}
      </itl-card>
      <itl-card [header]="'integratedCare.articleLine.serialNo' | translate">
        {{ articleLine.serialNumber ? articleLine.serialNumber : 'k.A.' }}
      </itl-card>
      <itl-card *ngIf="articleLine.active && articleLine.maxAmount" [header]="'order.edit.maxQuantity' | translate">
        {{ article.inventoryType | articleInventoryTypePipe }}
        <span
          [style.color]="
            articleLine.maxAmount.currentQuantity > articleLine.maxAmount.maxQuantityBaseOnScope ? '#d44949' : ''
          "
        >
          {{ articleLine.maxAmount.currentQuantity }} {{ 'order.edit.of' | translate }}
          {{ articleLine.maxAmount.maxQuantityBaseOnScope }}
        </span>
      </itl-card>
    </ng-container>
  </itl-integratedcare-article>

  <itl-single-order-article-list-item-button *ngIf="!isArticleEditDisabled">
    <div class="expandButton" (click)="editArticle(articleLine)">
      <button class="setRecommendedQuantity">
        <ion-icon id="edit" name="alberta-fab-edit"></ion-icon>
      </button>
    </div>
  </itl-single-order-article-list-item-button>
</itl-single-order-article-list-item>
